<h3>Top Heroes</h3>
<div class="grid grid-pad">
  <a
    *ngFor="let hero of heroes"
    class="col-1-4"
    routerLink="/detail/{{ hero.id }}"
  >
    <div class="module hero">
      <h4>{{ hero.name }}</h4>
    </div>
  </a>
</div>

<app-hero-search></app-hero-search>
